(function ($) {
    'use strict';

    $.fn.firstVisitPopup = function (settings) {
        var $var_popup_wrapper;

        var setCookie = function (name, value) {
            var date = new Date(),
                expires = 'expires=';
            date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000)); // 30 days
            expires += date.toGMTString();
            document.cookie = name + '=' + value + '; ' + expires + '; path=/';
        }

        var getCookie = function (name) {
            var allCookies = document.cookie.split(';'),
                cookieCounter = 0,
                currentCookie = '';
            for (cookieCounter = 0; cookieCounter < allCookies.length; cookieCounter++) {
                currentCookie = allCookies[cookieCounter];
                while (currentCookie.charAt(0) === ' ') {
                    currentCookie = currentCookie.substring(1, currentCookie.length);
                }
                if (currentCookie.indexOf(name + '=') === 0) {
                    return currentCookie.substring(name.length + 1, currentCookie.length);
                }
            }
            return false;
        }

        var showMessage = function () {
            setTimeout(function () {
                $var_popup_wrapper.css({ "opacity": "1", "visibility": "visible", "transition": ".5s" }).fadeIn(500);
            }, 5000); // Show after 5 seconds
        }

        var hideMessage = function () {
            $var_popup_wrapper.fadeOut(500);
            setCookie('fvpp' + settings.cookieName, 'true');
        }

        $var_popup_wrapper = $('.popup_wrapper');

        // Check if user has seen popup before (first-time visitor logic)
        var hasSeenPopup = getCookie('fvpp' + settings.cookieName);
        console.log('First-time visitor check:', hasSeenPopup ? 'Has seen popup before' : 'First-time visitor');

        if (hasSeenPopup) {
            // User has seen popup before, don't show it
            hideMessage();
        } else {
            // First-time visitor, show the popup
            showMessage();
        }

        $(".popup_off").on('click', hideMessage);
    };

})(jQuery);

// Initialize popup when document is ready
$(document).ready(function () {

    // Check if popup should be shown (only on homepage and if enabled)
    var isHomepage = window.location.pathname === '/' ||
        window.location.pathname === '/index' ||
        window.location.pathname === '' ||
        window.location.pathname.match(/^\/$/) ||
        window.location.pathname.match(/^\/index$/);

    console.log('Newsletter popup initialization:');
    console.log('- Current path:', window.location.pathname);
    console.log('- Is homepage:', isHomepage);
    console.log('- Newsletter enabled:', typeof window.newsletterPopupEnabled !== 'undefined' ? window.newsletterPopupEnabled : 'undefined');
    console.log('- First-time visitor mode:', typeof window.oneDayPopupEnabled !== 'undefined' ? window.oneDayPopupEnabled : 'undefined');

    if (isHomepage &&
        typeof window.newsletterPopupEnabled !== 'undefined' &&
        window.newsletterPopupEnabled) {

        // Wait for popup element to be available
        var checkPopup = setInterval(function () {
            if ($('#one-time-newsletter').length) {
                clearInterval(checkPopup);

                // Check if first-time visitor mode is enabled
                if (typeof window.oneDayPopupEnabled !== 'undefined' && window.oneDayPopupEnabled) {
                    // First-time visitor mode: use cookie logic
                    console.log('Using first-time visitor mode (cookie logic)');
                    $('#one-time-newsletter').firstVisitPopup({
                        cookieName: 'index'
                    });
                } else {
                    // Always show mode: show popup every time after 5 seconds
                    console.log('Using always show mode (no cookie logic)');
                    setTimeout(function () {
                        $('.popup_wrapper').css({ "opacity": "1", "visibility": "visible" });
                        $('.popup_off').click(function () {
                            $(".popup_wrapper").fadeOut(200);
                        });
                    }, 5000);
                }

                // Handle "Don't show again" functionality
                if (localStorage.getItem("DontShow")) {
                    $("#one-time-newsletter").hide();
                }

                $("#forgetMe").on("click", function () {
                    localStorage.setItem("DontShow", "true");
                });


                // Handle success message close button
                $('.success-form-close-btn').on('click', function () {
                    $('.form-message--success').slideToggle();
                });

                // Handle form submission success
                $('form[id*="Contact_"]').on('submit', function (e) {
                    // Add a small delay to allow form processing
                    setTimeout(function () {
                        if ($('.form-message--success').length) {
                            // Hide popup after successful submission
                            setTimeout(function () {
                                $('.popup_wrapper').fadeOut(500);
                            }, 2000);
                        }
                    }, 100);
                });
            }
        }, 100);

        // Timeout after 10 seconds if popup element not found
        setTimeout(function () {
            if (checkPopup) {
                clearInterval(checkPopup);
            }
        }, 10000);
    }
});